import * as Yup from 'yup';
import { Viewing } from '@models';

export function useValidationSchema() {
  return Yup.object<Viewing>().shape({
    user: Yup.mixed().nullable().required(),
    availableFrom: Yup.mixed().nullable().required(),
  });
}
